<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="suburbs"
      :search="search">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Suburbs</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-dialog
            v-model="showFareAddonDialog"
            persistent
            max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                @click="showNewFareAddons">Edit Fare Addons</v-btn>
            </template>
            <v-card>
              <v-card-title>
              </v-card-title>
              <v-card-text>
                <FareAddons
                  :items="allFareAddons"
                  :directions="directions">
                </FareAddons>
              </v-card-text>
               <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeAllFareAddons">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveAllFareAddons">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="showExtraChargesDialog"
            persistent
            max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-6"
                color="primary"
                dark
                @click="showExtraCharges">Edit Extra charges</v-btn>
            </template>
            <v-card>
              <v-card-title>
              </v-card-title>
              <v-card-text>
                <ExtraCharges
                  :items="extraCharges">
                </ExtraCharges>
              </v-card-text>
               <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeExtraCharges">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveExtraCharges">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            single-line
            hide-details></v-text-field>
          <v-dialog
            v-model="dialog"
            persistent
            max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="ml-1 mb-2"
                v-bind="attrs"
                @click="resetCurrentItem()"
                v-on="on">
                New Item
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="suburb" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="suburbValid">
                    <v-container>
                      <v-row>
                      <v-col cols="12">
                          <ValidationProvider
                            rules="required"
                            name="Suburb name"
                            vid="suburbName"
                            v-slot="{ errors }">
                            <v-text-field
                              dense
                              v-model="editedItem.suburbName"
                              :error-messages="errors"
                              label="Suburb name"
                              append-icon="mdi-card-bulleted-outline"
                              placeholder="'Enter suburb name'">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols="12">
                        <ValidationProvider
                            rules="required"
                            name="Pass time"
                            vid="passTime"
                            v-slot="{ errors }">
                            <v-text-field
                              dense
                              :error-messages="errors"
                              v-model="editedItem.passTime"
                              v-mask="timeMask"
                              label="Pass time">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <ValidationProvider
                            tag="div"
                            rules="required"
                            name="Zone"
                            v-slot="{ errors }">
                            <v-select
                              :error-messages="errors"
                              :items="zones"
                              item-text="zoneDescription"
                              item-value="zoneId"
                              label="Zone"
                              outlined
                              dense
                              v-model="editedItem.zoneId">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6">
                          <ValidationProvider
                            tag="div"
                            rules="required"
                            name="Area"
                            v-slot="{ errors }">
                            <v-select
                              :error-messages="errors"
                              :items="areas"
                              item-text="areaName"
                              item-value="areaId"
                              label="Area"
                              outlined
                              dense
                              v-model="editedItem.areaId">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Price first passenger"
                            vid="priceFirstPassenger"
                            v-slot="{ errors }">
                            <v-currency-field
                              dense
                              :error-messages="errors"
                              label="Price first passenger"
                              v-model="editedItem.priceFirstPassenger"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="6">
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Price additional passenger"
                            vid="priceAdditionalPassenger"
                            v-slot="{ errors }">
                            <v-currency-field
                              dense
                              :error-messages="errors"
                              label="Price additional passenger"
                              v-model="editedItem.priceAdditionalPassenger"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4">
                           <ValidationProvider
                            rules="required|min_value:1"
                            name="Price private 1 to 2"
                            vid="pricePrivate1to2"
                            v-slot="{ errors }">
                            <v-currency-field
                              dense
                              :error-messages="errors"
                              label="Price private 1 to 2"
                              v-model="editedItem.pricePrivate1to2"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="4">
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Price private 3 to 7"
                            vid="pricePrivate3to7"
                            v-slot="{ errors }">
                            <v-currency-field
                              dense
                              :error-messages="errors"
                              label="Price private 3 to 7"
                              v-model="editedItem.pricePrivate3to7"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="4">
                          <ValidationProvider
                            rules="required|min_value:1"
                            name="Price private 8 to 14"
                            vid="pricePrivate8to14"
                            v-slot="{ errors }">
                            <v-currency-field
                              dense
                              :error-messages="errors"
                              label="Price private 8 to 14"
                              v-model="editedItem.pricePrivate8to14"
                              prefix="$"
                              type="number"
                              money="money">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4">
                          <v-text-field
                            dense
                            label="Run Id"
                            v-model="editedItem.runId"
                            type="number">
                          </v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-checkbox
                            dense
                            label="Is active"
                            @change="isActiveChanged"
                            v-model="editedItem.isActive" />
                        </v-col>
                        <v-col cols="4">
                          <v-checkbox
                            dense
                            label="Is exclusive only"
                            @change="isExclusiveOnlyChanged"
                            v-model="editedItem.isExclusiveOnly" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <FareAddons
                            :items="editedItem.fareAddons"
                            :directions="directions">
                          </FareAddons>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </ValidationObserver>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="saveSuburb">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.priceFirstPassenger="{ item }">
          {{ item.priceFirstPassenger | toCurrency }}
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-simple-checkbox
          v-model="item.isActive"
          disabled>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.isExclusiveOnly="{ item }">
        <v-simple-checkbox
          v-model="item.isExclusiveOnly"
          disabled>
        </v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editSuburb(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { mask } from 'vue-the-mask';
/* eslint-disable camelcase */
import { required, min_value } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';
import FareAddons from '@/components/FareAddons.vue';
import ExtraCharges from '@/components/ExtraCharges.vue';

setInteractionMode('eager');

extend('required', required);
extend('min_value', min_value);

export default {
  name: 'suburbs',
  components: {
    ValidationObserver,
    ValidationProvider,
    FareAddons,
    ExtraCharges,
  },
  directives: {
    mask,
  },
  data: () => ({
    timeMask: '##:##:##',
    showFareAddonDialog: false,
    showExtraChargesDialog: false,
    allFareAddons: [],
    extraCharges: [],
    suburbs: [],
    zones: [],
    areas: [],
    directions: [],
    dialog: false,
    suburbValid: false,
    editedItem: {},
    defaultItem: {
      id: undefined,
      suburbName: '',
      passTime: undefined,
      priceFirstPassenger: 0,
      priceAdditionalPassenger: 0,
      pricePrivate1to2: 0,
      pricePrivate3to7: 0,
      pricePrivate8to14: 0,
      zoneId: undefined,
      areaId: undefined,
      runId: undefined,
      fareAddons: [],
      isActive: undefined,
      isExclusiveOnly: undefined,
    },
    search: '',
    editedIndex: -1,
    headers: [
      {
        text: 'Suburb',
        align: 'start',
        sortable: false,
        value: 'suburbName',
      },
      { text: 'Pass time', value: 'passTime' },
      { text: 'Price first pax', value: 'priceFirstPassenger' },
      { text: 'Active', value: 'isActive' },
      { text: 'Exclusive Only', value: 'isExclusiveOnly' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters([storeConstants.SUBURBS,
      storeConstants.ZONES,
      storeConstants.AREAS,
      storeConstants.DIRECTIONS,
      storeConstants.ALL_FARE_ADDONS,
      storeConstants.IS_ADMINISTRATOR,
      storeConstants.EXTRA_CHARGES]),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
    ]),
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },
  mounted() {
    this.GET_SUBURBS()
      .then(() => {
        this.suburbs = this.SUBURBS;
        this.zones = this.ZONES;
        this.areas = this.AREAS;
        this.directions = this.DIRECTIONS;
        this.allFareAddons = this.ALL_FARE_ADDONS;
        this.isLoading = false;
      },
      (error) => {
        this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  methods: {
    ...mapActions([storeConstants.GET_SUBURBS,
      storeConstants.SAVE_SUBURB,
      storeConstants.SAVE_ALL_FARE_ADDONS,
      storeConstants.GET_EXTRA_CHARGES,
      storeConstants.SAVE_EXTRA_CHARGES]),
    isActiveChanged(val) {
      if (val === true) {
        this.editedItem.isExclusiveOnly = false;
      }
    },
    isExclusiveOnlyChanged(val) {
      if (val === true) {
        this.editedItem.isActive = false;
      }
    },
    resetCurrentItem() {
      this.clearEditSuburbItem();
    },
    close() {
      this.dialog = false;
      this.clearEditSuburbItem();
    },
    editSuburb(item) {
      this.editedIndex = this.suburbs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    saveSuburb() {
      this.$refs.suburb.validate().then((success) => {
        this.suburbValid = success;
        if (this.suburbValid) {
          this.SAVE_SUBURB(this.editedItem)
            .then(() => {
              this.suburbs = this.SUBURBS;
              this.zones = this.ZONES;
              this.areas = this.AREAS;
              this.directions = this.DIRECTIONS;
              this.clearEditSuburbItem();
              this.dialog = false;
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    cancel() {
      this.dialog = false;
    },
    clearEditSuburbItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    showNewFareAddons() {
      this.showFareAddonDialog = true;
    },
    showExtraCharges() {
      this.GET_EXTRA_CHARGES()
        .then(() => {
          this.extraCharges = this.EXTRA_CHARGES;
          this.showExtraChargesDialog = true;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    closeExtraCharges() {
      this.showExtraChargesDialog = false;
    },
    saveExtraCharges() {
      this.SAVE_EXTRA_CHARGES(this.extraCharges)
        .then(() => {
          // this.extraCharges = this.EXTRA_CHARGES;
          this.showExtraChargesDialog = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    saveAllFareAddons() {
      this.SAVE_ALL_FARE_ADDONS(this.allFareAddons)
        .then(() => {
          this.allFareAddons = this.ALL_FARE_ADDONS;
          this.showFareAddonDialog = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    closeAllFareAddons() {
      this.showFareAddonDialog = false;
    },
  },
};
</script>
<style>
  .fareAddon-deleted {
    color: #ff0000;
    text-decoration: line-through;
  }
</style>
